var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ax-navbar__link",
      class: { "ax-navbar__link--active": _vm.showMenu },
      attrs: { id: _vm.menuId, "aria-label": _vm.menuId, role: "navigation" }
    },
    [
      _vm.computedItems.length
        ? _c(
            "button",
            {
              staticClass: "ax-navbar__top-level-menu-item",
              attrs: { "aria-label": "show sub menu" },
              on: {
                click: _vm.toggleMenu,
                keyup: _vm.toggleMenu,
                mouseover: _vm.hoverMenu,
                mouseleave: _vm.hoverLeave,
                focusin: _vm.hoverMenu,
                focusout: _vm.hoverLeave
              }
            },
            [
              _c("caption", { staticClass: "menu-caption" }, [
                _vm._v("\n            " + _vm._s(_vm.caption) + "\n        ")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showMenu
        ? _c(
            "div",
            { staticClass: "ax-navbar__second-level-container" },
            _vm._l(_vm.computedItems, function(column) {
              return _c(
                "ul",
                {
                  key: column.caption,
                  staticClass: "ax-navbar__second-level-column"
                },
                [
                  _vm._l(column, function(group, index) {
                    return [
                      _vm._l(group.items, function(item) {
                        return [
                          _c("second-level-menu-item", {
                            key: item.caption,
                            attrs: { itemData: item },
                            on: {
                              "reset-third-levels": _vm.resetThirdLevels,
                              navigate: _vm.navigate
                            }
                          })
                        ]
                      }),
                      _vm._v(" "),
                      index != Object.keys(column).length - 1
                        ? _c(
                            "li",
                            {
                              key: group.caption + "break",
                              staticClass: "ax-navbar__break-row"
                            },
                            [_vm._m(0, true)]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticClass: "ax-navbar__group-break", attrs: { colspan: "3" } },
      [_c("hr")]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }